export default __webpack_public_path__ + "media/note.8463feef.svg";